module.exports = __webpack_public_path__ + "static/media/productos_pepita_amarilla_tostada.398808f4.png";